import { DocumentState } from "./types";
import { margin } from "./constants";

export const createDocumentState = (): DocumentState => ({
  x: 2,
  y: 2,
  startYTable: 25,
  startXSignature: 90
});


export function splitMerchantProducts(merchants: any[], limit = 10): any[] {
  const result: any[] = [];

  merchants.forEach((merchant) => {
    const products = merchant.products || [];
    const totalChunks = Math.ceil(products.length / limit);

    for (let i = 0; i < totalChunks; i++) {
      const chunk = products.slice(i * limit, (i + 1) * limit);

      result.push({
        ...merchant,
        products: chunk,
      });
    }
  });

  return result;
}
